/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_PermissionsInputs */

const de__field_permissions = /** @type {(inputs: _Field_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`errechnete Berechtigungen`)
};

/**

* @param {_Field_PermissionsInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_permissions = /** @type {((inputs?: _Field_PermissionsInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_PermissionsInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_permissions(inputs)
});